import { render, staticRenderFns } from "./Staff.vue?vue&type=template&id=9c08a2d0&scoped=true"
import script from "./Staff.vue?vue&type=script&lang=js"
export * from "./Staff.vue?vue&type=script&lang=js"
import style0 from "./Staff.vue?vue&type=style&index=0&id=9c08a2d0&prod&lang=scss&scoped=true"
import style1 from "./Staff.vue?vue&type=style&index=1&id=9c08a2d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c08a2d0",
  null
  
)

export default component.exports